document.addEventListener('DOMContentLoaded', function () {
  // Initialize collapsible section-title-row for mobile table ONLY
  function initCollapsibleRows() {
    const isMobile = window.innerWidth <= 768;
    
    // Remove all event listeners and reset display on desktop
    document.querySelectorAll('.section-title-row[data-section-toggle]').forEach(function (titleRow) {
      const toggleId = titleRow.getAttribute('data-section-toggle');
      const titleCell = titleRow.querySelector('.section-title-cell');
      
      if (!isMobile) {
        // Desktop: remove collapsed state and show all rows
        titleRow.classList.remove('is-collapsed');
        if (titleCell) {
          titleCell.removeAttribute('data-initialized');
          titleCell.style.cursor = '';
        }
        
        // Show all rows
        let nextRow = titleRow.nextElementSibling;
        while (nextRow && !nextRow.classList.contains('section-title-row')) {
          if (nextRow.hasAttribute('data-section-content') && 
              nextRow.getAttribute('data-section-content') === toggleId) {
            nextRow.style.display = '';
          }
          nextRow = nextRow.nextElementSibling;
        }
        return;
      }
      
      // Mobile: add click handler
      if (titleCell && !titleCell.hasAttribute('data-initialized')) {
        titleCell.setAttribute('data-initialized', 'true');
        
        titleCell.addEventListener('click', function () {
          const isCollapsed = titleRow.classList.contains('is-collapsed');
          
          // Hide/show all rows with matching section-content until next section-title-row
          let nextRow = titleRow.nextElementSibling;
          while (nextRow && !nextRow.classList.contains('section-title-row')) {
            if (nextRow.hasAttribute('data-section-content') && 
                nextRow.getAttribute('data-section-content') === toggleId) {
              if (isCollapsed) {
                nextRow.style.display = '';
              } else {
                nextRow.style.display = 'none';
              }
            }
            nextRow = nextRow.nextElementSibling;
          }
          
          // Toggle collapsed state
          if (isCollapsed) {
            titleRow.classList.remove('is-collapsed');
          } else {
            titleRow.classList.add('is-collapsed');
          }
        });
      }
    });
  }

  // Initialize on load
  initCollapsibleRows();

  // Re-initialize on resize (collapsible rows only)
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // Remove all initialized flags to reinitialize collapsible behavior
      document.querySelectorAll('.section-title-cell[data-initialized]').forEach(function (cell) {
        cell.removeAttribute('data-initialized');
      });
      initCollapsibleRows();
    }, 250);
  });
});

